// extracted by mini-css-extract-plugin
export default {"graphDesktop":"MonthGraph_graphDesktop__IzPFI","graphSm":"MonthGraph_graphSm__4BwRB"};